import _ from "lodash";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { dateTimeStamp, SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import Loader from "../Loader/Loader";
import { useTranslation } from "react-i18next";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { Col } from "react-bootstrap";
import { getFileUploadOnAWS } from "../../redux/events/actions";
import SimplePopup from "../modal/SimplePopup";
import "../../pages/GroupWorkshop/GroupWorkShop.scss";
import { addSessionNotes, addSessionNotesClear } from "../../redux/coaching/actions";
import ConfirmModal from "../modal/ConfirmModal";

const SessionNoteAddModal = (props) => {
  const {   
    filteredData, 
    showAddCoachModal,
    setShowAddCoachModal,
    getCoachNotesDataReq,
    setIsLoading,
    isLoading,
    refreshList,
    timezone,
    sessionId,    
    sessionStartDate,
    sessionStartTime,
    sessionEndTime
  } = props;
  console.log("sessionStartTime",sessionStartTime)
  const { t } = useTranslation();     
  const search = window.location.search;
  const params = new URLSearchParams(search);  
  const dispatch = useDispatch();  
  const addSessionNotesStore = useSelector((state)=> state.coaching.addSessionNotes)
  const userDetailRes = useSelector((state) => state.user.userBroker);

  const [isDocLoading, setIsDocLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [apiCalled, setApiCalled] = useState(false);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const [error, setError] = useState("");  
  const [notes, setNotes] = useState("");
  const [isFetching, setIsFetching] = useState(false);  
  const [errorMsg, setErrorMsg] = useState("");
  const [errorType, setErrorType] = useState("");
  const [confirmModal,setConfirmModal] = useState(false);
  const [showModalMsg,] = useState('Session notes added successfully.')
  const [hide,setHide] = useState(false);
  const [notesError, setNotesError] = useState(false);  

  const addNotes = () => {    
    if(!notes){      
      setNotesError(true);
      return;
    }    
    // && !_.isEmpty(documents)
    if(notes  && sessionId ) {
      setHide(true);
      dispatch(
        addSessionNotes({
          module: "addCoachingSessionNotes",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),  //"334107db-cf44-4a72-acc3-904009e78e91",            
            coach_session_id : sessionId ? sessionId : "",
            note: notes,
            files: documents ? documents : "",               
          },
        })
      ); 
    }                 
  }

  useEffect(() => {
    console.log("addSessionNotesStore: ", addSessionNotesStore);
    if (!_.isEmpty(addSessionNotesStore)) {
      if (addSessionNotesStore?.status === "success") {  
        getCoachNotesDataReq();
        setHide(false);
        setConfirmModal(true);
        dispatch(addSessionNotesClear());
        // setShowAddCoachModal(false);
  //       let response = addSessionNotes?.payload?.payload;
  //       setIsFetching(false);
  //       setShowAddCoachModal(false);
  //       refreshList();
      }else{
        setHide(false);
        setError("Something went wrong.");
        setShowLimitPopup(true);
      }
    }
  }, [addSessionNotesStore]);  

  const callS3API = (file, type, name, size, dateModified) => {
    setApiCalled(true);
    // setIsLoading(true);
    let fileType = type?.includes("pdf")
      ? "pdf"
      : type?.includes("image")
      ? "image"
      : "pdf";
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("file", file);
    formData.append("type", fileType);
    formData.append("dateModified", dateModified);    
    dispatch(getFileUploadOnAWS(formData));
  };

  const deleteFileFromResourceList = (id) => {
    let updatedResources = documents.filter((item) => item?.id != id);
    setDocuments(updatedResources);
  };

  var fileRes = useSelector((state) => state.events.fileUploadAWSData);

  useEffect(() => {
    if (!_.isEmpty(fileRes) && apiCalled) {
      if (fileRes?.status === "success") {
        let obj = {
          id: Math.round(Math.random() * 9999),
          name: fileRes?.name,
          type: fileRes?.type,
          url: fileRes?.file_url,
          dateModified: fileRes?.dateModified,
          size: fileRes?.size,
        };

        setDocuments((resource) => [...resource, obj]);
        setIsDocLoading(false);
      } else {
        setError("failed to upload");
        setShowLimitPopup(true);
        setIsDocLoading(false);
      }
    }
    setApiCalled(false);
  }, [fileRes]);

  const downloadPDF = async (pdfUrl, name) => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}`); // Specify the name for the downloaded file
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link); // Clean up the DOM
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };

  const handleResourceFileChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      const selectedFiles = e.target.files;
      const allowedExtensions = [
        "png",
        "jpeg",
        "mp4",
        "3ggp",
        "m3u8",
        "avi",
        "mov",
        "mkv",
        "flv",
        "wmv",
      ];
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        // Get the file details
        const fileName = file.name;
        
        const fileSize = file.size; // in bytes
        const fileType = file.type;
        const fileLastModified = file.lastModified;
        console.log("filename",fileName,fileSize,fileType,fileLastModified)

        if (
          allowedExtensions.includes(fileType) ||
          _.toLower(fileType).includes("video")
        ) {
          setError(t("invalidFileType"));
          setShowLimitPopup(true);
        } else if (fileSize > 20 * 1048576) {
          setError(t("fileSizeError"));
          setShowLimitPopup(true);
        } else {
          setError("");
          setIsDocLoading(true);
          callS3API(file, fileType, fileName, fileSize, fileLastModified);
        }
      }
    }
  };

  return (
    <>
    {!confirmModal ? 
    <Modal
      show={showAddCoachModal}
      onHide={() => {
        setShowAddCoachModal(false);
      }}
      dialogclassName="modal-60w"
      aria-labelledby="contained-modal-title-vcenter"
      className="custom-modal"
      centered
      size="lg"
    >
      {/* <Modal.Header closeButton className="modal-header">
            <Modal.Title>Favourite Delete Alert</Modal.Title>
        </Modal.Header> */}
      <Modal.Header closeButton className="p-4 border-0">
        <Modal.Title className="mentor-title mb-0">          
           {t("Add Session Note")}            
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modalfrm group-worshopdetail-frm">
          <Loader start={isFetching} />
          <div className="row mb-3">
            <div className="col-md-4">
              <label for="sessionStartDate-0" className="form-label">
                Start Date
              </label>
              <div className="position-relative datepic">
              <div className="react-datepicker-wrapper">
                <div className="react-datepicker__input-container">
                  <input type="text" name="" placeholder="YYYY-MM-DD" className="form-control "
                   value={sessionStartDate}
                    disabled />
                  </div>
                </div>
                <span className="cal"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none"><path d="M6.1875 2.5H11.8125V0.9375C11.8125 0.429688 12.2031 0 12.75 0C13.2578 0 13.6875 0.429688 13.6875 0.9375V2.5H15.25C16.6172 2.5 17.75 3.63281 17.75 5V17.5C17.75 18.9062 16.6172 20 15.25 20H2.75C1.34375 20 0.25 18.9062 0.25 17.5V5C0.25 3.63281 1.34375 2.5 2.75 2.5H4.3125V0.9375C4.3125 0.429688 4.70312 0 5.25 0C5.75781 0 6.1875 0.429688 6.1875 0.9375V2.5ZM2.125 17.5C2.125 17.8516 2.39844 18.125 2.75 18.125H15.25C15.5625 18.125 15.875 17.8516 15.875 17.5V7.5H2.125V17.5Z" fill="#2D2D2D"></path></svg></span>
              </div>
            </div>
            
            <div className="col-md-4">
              <label for="" className="form-label">
                Start Time
              </label>
              <div className="position-relative datepic">
              <div className="react-datepicker-wrapper">
                <div className="react-datepicker__input-container">
                  <input type="text" name="" placeholder="hh:mm aa" className="form-control "                  
                  value={sessionStartTime}

                   disabled />
                  </div>
                </div>
                <span className="cal">
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ClockIcon"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></svg></span>
              </div>
            </div>
            <div className="col-md-4">
              <label for="" className="form-label">
                End Time
              </label>
              <div className="position-relative datepic">
              <div className="react-datepicker-wrapper">
                <div className="react-datepicker__input-container">
                  <input type="text" name="" placeholder="hh:mm aa" className="form-control "
                   value= {sessionEndTime}
                   disabled />
                  </div>
                </div>
                <span className="cal">
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ClockIcon"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></svg></span>
              </div>
            </div>
          </div>
          {/* <div className="input-text mb-3">
            <label htmlFor="first_name" className="input__label">
              {t("Session Title")}<sup className="text-danger">*</sup>
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              className="input__field"
              placeholder="Enter title"
              value={title}
              onChange={(evt) => {
                setTitle(evt.target.value);
              }}              
            />
          </div>
          {errorType === "title" && <p className="error-msg">{errorMsg}</p>} */}
          <div className="input-text mb-3">
            <label htmlFor="first_name" className="input__label">
              {t("Notes")}<sup className="text-danger">*</sup>
            </label>
            <textarea
              type="text"
              id="first_name"
              name="first_name"
              className="input__field"
              placeholder="Notes here..."
              value={notes}
              onChange={(evt) => {
                setNotes(evt.target.value);
                setNotesError(false);
              }}              
            ></textarea>
            {/* {errorType === "notes" && <p className="error-msg">{errorMsg}</p>} */}
            {notesError && <span className="text-danger" style={{fontSize:'.8rem'}}>Please mention session notes</span>}
          </div>
          <div className="group-worshopdetail-frmsec mb-3">
            <label htmlFor="workshopResource" className="form-label">
              {t("Upload Documents")}{" "}
            </label>
            <div className="d-flex  gap-5">
              <div
                className={`file-uploader`}                               
              >
                <div className="d-flex flex-column justify-content-center align-items-center gap-2 w-100 cursor-pointer file-section" onClick={() => document.getElementById("file2").click()}>
                <div className="iocn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="18"
                    viewBox="0 0 24 18"
                    fill="none"
                  >
                    <path
                      d="M11.3691 6.05273C11.7031 5.71875 12.2598 5.71875 12.5938 6.05273L15.5625 9.02148C15.9336 9.39257 15.9336 9.94921 15.5625 10.2832C15.2285 10.6543 14.6719 10.6543 14.3379 10.2832L12.8906 8.83593V13.8086C12.8906 14.3281 12.4824 14.6992 12 14.6992C11.4805 14.6992 11.1094 14.3281 11.1094 13.8086V8.83593L9.625 10.2832C9.29102 10.6543 8.73438 10.6543 8.40039 10.2832C8.0293 9.94921 8.0293 9.39257 8.40039 9.02148L11.3691 6.05273ZM5.46875 17.3711C2.5 17.3711 0.125 14.9961 0.125 12.0274C0.125 9.72656 1.60938 7.72265 3.6875 7.01757V6.98047C3.6875 3.5664 6.4707 0.746094 9.92188 0.746094C11.7773 0.746094 13.4844 1.59961 14.6348 2.93554C15.1914 2.67578 15.7852 2.52734 16.4531 2.52734C18.9023 2.52734 20.9062 4.53125 20.9062 6.98047C20.9062 7.24023 20.8691 7.46289 20.832 7.72265C22.6133 8.50195 23.875 10.2832 23.875 12.3242C23.875 15.0332 21.7598 17.2227 19.125 17.3711H5.46875ZM9.92188 2.52734C7.43555 2.52734 5.46875 4.53125 5.46875 6.98047V8.27929L4.24414 8.6875C2.87109 9.16992 1.90625 10.5059 1.90625 12.0274C1.90625 13.9941 3.46484 15.5898 5.46875 15.5898H18.9023H19.0137C20.7207 15.5156 22.0938 14.0684 22.0938 12.3242C22.0938 10.9883 21.2773 9.83789 20.127 9.35547L18.8652 8.79882L19.0879 7.42578C19.0879 7.27734 19.125 7.1289 19.125 6.98047C19.125 5.5332 17.9004 4.30859 16.4531 4.30859C16.0449 4.30859 15.6738 4.41992 15.3398 4.56836L14.1523 5.08789L13.2617 4.08593C12.4453 3.1582 11.2578 2.52734 9.88477 2.52734H9.92188Z"
                      fill="#2D2D2D"
                    />
                  </svg>
                </div>
                <div className="textf">FILE FORMAT(S)</div>
                <div className="filemsg">
                  {t("dropUpTo20MBFilesHereToUploadOr")}
                </div>
                <label
                  for="file-upload1"
                  className={`upload-link chossefiles `}
                >
                  {t("chooseFiles")}
                </label>
                <input
                  type="file"
                  id="file2"
                  className="upload-input"
                  accept=".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx"
                  onChange={handleResourceFileChange}
                />  
                </div>                               

                <div className="w-100">
                  {documents?.map((item) => {
                    return (
                      <ul className="listinguploadee  mt-4">
                        <li>
                          <span className="lef-infopx1">
                            <span className="iconxload">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="23"
                                viewBox="0 0 18 23"
                                fill="none"
                              >
                                <path
                                  d="M16.4336 4.09765L13.2109 0.875004C12.6953 0.359374 12.0078 0.0585938 11.2773 0.0585938H3.5C1.95312 0.0585938 0.75 1.30468 0.75 2.80859V19.3086C0.75 20.8555 1.95312 22.0586 3.5 22.0586H14.5C16.0039 22.0586 17.25 20.8555 17.25 19.3086V6.03125C17.25 5.30078 16.9492 4.61328 16.4336 4.09765ZM15.1875 19.3086C15.1875 19.6953 14.8438 19.9961 14.5 19.9961H3.5C3.11328 19.9961 2.8125 19.6953 2.8125 19.3086V2.85156C2.8125 2.46484 3.11328 2.16406 3.5 2.16406H10.375V5.55859C10.375 6.33203 10.9766 6.93359 11.75 6.93359H15.1445V19.3086H15.1875ZM9.98828 12.6055C9.77344 12.6055 9.60156 12.7344 9.47266 12.9063L7.79688 15.4414L7.28125 14.7109C7.15234 14.5391 6.98047 14.4102 6.76562 14.4102C6.59375 14.4102 6.37891 14.5391 6.29297 14.7109L4.27344 17.7188C4.14453 17.8906 4.14453 18.1484 4.23047 18.3203C4.35938 18.5352 4.53125 18.6211 4.74609 18.6211H13.168C13.3828 18.6211 13.5977 18.5352 13.6836 18.3203C13.7695 18.1484 13.7695 17.8906 13.6406 17.7188L10.4609 12.9063C10.375 12.7344 10.2031 12.6055 9.98828 12.6055ZM6.25 12.4336C6.98047 12.4336 7.625 11.832 7.625 11.0586C7.625 10.3281 6.98047 9.68359 6.25 9.68359C5.47656 9.68359 4.875 10.3281 4.875 11.0586C4.875 11.832 5.47656 12.4336 6.25 12.4336Z"
                                  fill="#2D2D2D"
                                />
                              </svg>
                            </span>
                            <span className="filename">{item?.name}</span>
                          </span>
                          <span className="rightds">
                            <span className="filtduploaddate">
                              {item?.dateModified &&
                                dateTimeStamp(item?.dateModified) + " | "}
                              {item?.size > 0 &&
                                (item?.size / (1024 * 1024)).toFixed(2) + "MB"}
                            </span>
                            <span className="downloandicon d-flex gap-2">
                              <svg
                                className="cursor-pointer iconde"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="23"
                                viewBox="0 0 20 23"
                                fill="none"
                                onClick={() => {
                                  downloadPDF(item?.url, item?.name);
                                }}
                              >
                                <path
                                  d="M15.5 22.0586H4.5C2.17969 22.0586 0.375 20.2539 0.375 17.9336V14.8398C0.375 14.2813 0.804688 13.8086 1.40625 13.8086C1.96484 13.8086 2.4375 14.2813 2.4375 14.8398V17.9336C2.4375 19.0938 3.33984 19.9961 4.5 19.9961H15.5C16.6172 19.9961 17.5625 19.0938 17.5625 17.9336V14.8398C17.5625 14.2813 17.9922 13.8086 18.5938 13.8086C19.1523 13.8086 19.625 14.2813 19.625 14.8398V17.9336C19.625 20.2109 17.7773 22.0586 15.5 22.0586ZM10.6875 14.9258L16.5312 9.42579C16.9609 9.03906 16.9609 8.39453 16.5742 7.96484C16.1875 7.53515 15.543 7.53515 15.1133 7.92187L11.0312 11.7891V1.08984C11.0312 0.531254 10.5586 0.0585938 10 0.0585938C9.39844 0.0585938 8.96875 0.531254 8.96875 1.08984V11.7891L4.84375 7.92187C4.41406 7.53515 3.76953 7.53515 3.38281 7.96484C3.21094 8.17968 3.125 8.4375 3.125 8.65234C3.125 8.95312 3.21094 9.21093 3.42578 9.42579L9.26953 14.9258C9.65625 15.3125 10.3008 15.3125 10.6875 14.9258Z"
                                  fill="#2D2D2D"
                                />
                              </svg>
                              <svg
                                className={"cursor-pointer iconde"}
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="23"
                                viewBox="0 0 20 23"
                                fill="none"
                                onClick={() =>
                                  deleteFileFromResourceList(item?.id)
                                }
                              >
                                <path
                                  d="M7.28571 17.2461C7.28571 17.6328 6.94643 17.9336 6.60714 17.9336C6.22545 17.9336 5.92857 17.6328 5.92857 17.2461V8.30859C5.92857 7.96484 6.22545 7.62109 6.60714 7.62109C6.94643 7.62109 7.28571 7.96484 7.28571 8.30859V17.2461ZM10.6786 17.2461C10.6786 17.6328 10.3393 17.9336 10 17.9336C9.6183 17.9336 9.32143 17.6328 9.32143 17.2461V8.30859C9.32143 7.96484 9.6183 7.62109 10 7.62109C10.3393 7.62109 10.6786 7.96484 10.6786 8.30859V17.2461ZM14.0714 17.2461C14.0714 17.6328 13.7321 17.9336 13.3929 17.9336C13.0112 17.9336 12.7143 17.6328 12.7143 17.2461V8.30859C12.7143 7.96484 13.0112 7.62109 13.3929 7.62109C13.7321 7.62109 14.0714 7.96484 14.0714 8.30859V17.2461ZM13.9442 1.13281L15.5134 3.49609H18.4822C19.0334 3.49609 19.5 3.96875 19.5 4.52734C19.5 5.1289 19.0334 5.55859 18.4822 5.55859H18.1429V18.6211C18.1429 20.5547 16.616 22.0586 14.75 22.0586H5.25C3.34152 22.0586 1.85714 20.5547 1.85714 18.6211V5.55859H1.51786C0.924108 5.55859 0.5 5.1289 0.5 4.52734C0.5 3.96875 0.924108 3.49609 1.51786 3.49609H4.44419L6.0134 1.13281C6.4375 0.488284 7.20089 0.0585938 8.0067 0.0585938H11.9509C12.7567 0.0585938 13.5201 0.488284 13.9442 1.13281ZM6.90402 3.49609H13.0536L12.2477 2.29297C12.2054 2.20703 12.0782 2.12109 11.9509 2.12109H8.0067C7.87946 2.12109 7.75224 2.20703 7.70982 2.29297L6.90402 3.49609ZM3.89286 18.6211C3.89286 19.3945 4.4866 19.9961 5.25 19.9961H14.75C15.471 19.9961 16.1071 19.3945 16.1071 18.6211V5.55859H3.89286V18.6211Z"
                                  fill="#2D2D2D"
                                />
                              </svg>
                            </span>
                          </span>
                        </li>
                      </ul>
                    );
                  })}
                  {isDocLoading && (
                    <ul className="listinguploadee mt-4 ">
                      <ShimmerScreen case="rect" height="0.3125rem"
                    width="100%" />
                    </ul>
                  )}
                </div> 
                </div>             
            </div>
          </div>
        </div>
      </Modal.Body>      
        <Modal.Footer className="justify-content-end gap-3 border-0">
          <Button
            variant="primary"
            onClick={() => {
              setShowAddCoachModal(false);   
            }}
            disabled={hide}
          >
             {t("cancel") }
          </Button>
                    
          <Button
            variant="primary"
            onClick={() => {
              addNotes();
            }}
            disabled={hide}
          >
             {t("Add Note") }
          </Button>          
        </Modal.Footer>  
           
      <SimplePopup
        confirmModal={showLimitPopup}
        setConfirmModal={setShowLimitPopup}
        showModalMsg={error}
        isRightIcon={false}
      />
    </Modal>
    : ""}
    <ConfirmModal
    confirmModal={confirmModal}
    setConfirmModal={setConfirmModal}
    showModalMsg={showModalMsg}
    isConfirm={true}
    isConfirmwithNo={true}
    confirmId={""}
    confirmAction={() => {setShowAddCoachModal(false)
      setConfirmModal(false);      
    }}
    isRightIcon={true}
  /> 
  </>
  );
};

export default SessionNoteAddModal;
